// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__27MSt","content":"RecentSearches_content__3IPSl"};